import './stlawrencecollege/style';
import FormStructure from './stlawrencecollege/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js